export const capitalize = (text: string) =>
  text.toLowerCase().replace(/[^\s]+/g, (word: string) => word.replace(/^./, (first: string) => first.toUpperCase()))
